import Vue from 'vue';
import sissconst from './sissconst';
import { FieldType, CompareType, Filter } from '../store/entities/filter';
import { Dialog } from "vant"
import qs from 'qs';
declare global {
  interface Window {
    wx: any,
    BMap: any,
    layui: any
  }
}
class Util {
  public siss: any = window.siss;
  public _point: any = {};
  public _text: string = "";
  public MinVipMenuList: any = ["goods", "goods", "searchindex", "details", "todetails", "carttest", "contact", "addresslist", "addressedit", "myorder", "myordertest", "newindex", "brandindex",
    "confirmorder", "confirmorderwithoutcart", "seckillConfirmOrder", "oederdetails", "checkstand", "success", "spellgrouplist", "groupdetail", "seckilllist1", "seckilllist", "seckilldetail", "seckilldetail1", "buyfullpromotionlist",
    "buyfullpromotiondetail", "goodslist", "goodslistp", "goodslistc", "cancelorder", "spellgrouporder", "ordertrack"];
  public loadScript(url: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
  }
  public loadScriptBack(url: string, callback) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
    if (script.addEventListener) {
      script.addEventListener('load', function () {
        callback();
      }, false);
    }
  }
  public buildFilters(filters: Filter[]) {
    const fileswhere: string[] = [];
    filters.forEach((f) => {
      let where = '';
      if (f.Type === FieldType.Number) {
        where = this.buildNumber(f);
      } else if (f.Type === FieldType.String) {
        where = this.buildString(f);
      } else if (f.Type === FieldType.Boolean) {
        where = this.buildBoolean(f);
      } else if (f.Type === FieldType.DataRange || f.Type === FieldType.Date) {
        where = this.buildDate(f);
      } else if (f.Type === FieldType.Enum) {
        where = this.buildEnum(f);
      }
      if (where) {
        fileswhere.push(where);
      }

    });
    return fileswhere.join(' AND ');
  }
  public buildObjFilters(filters: Filter[]) {
    const fileswhere: any = {};
    filters.forEach((f) => {
      fileswhere[f.FieldName] = f.Value;
    });
    return fileswhere;
  }
  public title(title: string) {
    // tslint:disable-next-line:max-line-length
    const sissname = this.siss.localization.localize('sissName', sissconst.localization.defaultLocalizationSourceName);
    // tslint:disable-next-line:max-line-length
    const page = this.siss.localization.localize(title, sissconst.localization.defaultLocalizationSourceName);
    window.document.title = sissname + '--' + page;
  }
  public inOf(arr: any[], targetArr: any) {
    let res = true;
    arr.forEach((item) => {
      if (targetArr.indexOf(item) < 0) {
        res = false;
      }
    });
    return res;
  }
  public oneOf(ele: any, targetArr: any[]) {
    if (targetArr.indexOf(ele) >= 0) {
      return true;
    } else {
      return false;
    }
  }
  public showThisRoute(itAccess: any, currentAccess: any) {
    if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
      return this.oneOf(currentAccess, itAccess);
    } else {
      return itAccess === currentAccess;
    }
  }
  public getRouterObjByName(routers: any[], name?: string): any {
    if (!name || !routers || !routers.length) {
      return null;
    }
    let routerObj = null;
    for (const item of routers) {
      if (item.name === name) {
        return item;
      }
      routerObj = this.getRouterObjByName(item.children, name);
      if (routerObj) {
        return routerObj;
      }
    }
    return null;
  }
  public toDefaultPage(routers: any[], name: string | undefined, route: any, next: any) {
    const len = routers.length;
    let i = 0;
    let notHandle = true;
    while (i < len) {
      if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
        route.replace({
          name: routers[i].children[0].name,
        });
        notHandle = false;
        next();
        break;
      }
      i++;
    }
    if (notHandle) {
      next();
    }
  }
  public handleTitle(vm: any, item: any) {
    if (typeof item.meta.title === 'object') {
      return vm.$t(item.title.i18n);
    } else {
      return item.meta.title;
    }
  }
  public setCurrentPath(vm: Vue, name?: string) {
    let title = '';
    let isOtherRouter = false;
    vm.$store.state.siss.routers.forEach((item: any) => {
      if (item.children.length === 1) {
        if (item.children[0].name === name) {
          title = this.handleTitle(vm, item);
          if (item.name === 'otherRouter') {
            isOtherRouter = true;
          }
        }
      } else {
        item.children.forEach((child: any) => {
          if (child.name === name) {
            title = this.handleTitle(vm, child);
            if (item.name === 'otherRouter') {
              isOtherRouter = true;
            }
          }
        });
      }
    });
    let currentPathArr = [];
    if (name === 'home') {
      currentPathArr = [
        {
          // tslint:disable-next-line:max-line-length
          meta: { title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.siss.routers, 'home')) },
          path: 'home/home',
          name: 'home',
        },
      ];
    } else if (((name as string).indexOf('index') >= 0 || isOtherRouter) && name !== 'home') {
      currentPathArr = [
        {
          // tslint:disable-next-line:max-line-length
          meta: { title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.siss.routers, 'home')) },
          path: 'home/home',
          name: 'home',
        },
        {
          meta: { title },
          path: '',
          name,
        },
      ];
    } else {
      const currentPathObj = vm.$store.state.siss.routers.filter((item: any) => {
        if (item.children.length <= 1) {
          return item.children[0].name === name || item.name === name;
        } else {
          let i = 0;
          const childArr = item.children;
          const len = childArr.length;
          while (i < len) {
            if (childArr[i].name === name) {
              return true;
            }
            i++;
          }
          return false;
        }
      })[0];
      if (currentPathObj.children && currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
        currentPathArr = [
          {
            meta: { title: '首页' },
            path: 'home/home',
            name: 'home',
          },
        ];
        // tslint:disable-next-line:max-line-length
      } else if (currentPathObj.children && currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
        currentPathArr = [
          {
            meta: { title: '首页' },
            path: 'home/home',
            name: 'home',
          },
          {
            meta: { title: currentPathObj.meta.title },
            path: '',
            name,
          },
        ];
      } else {
        const childObj = currentPathObj.children.filter((child: any) => {
          return child.name === name;
        })[0];
        currentPathArr = [
          {
            meta: { title: '首页' },
            path: 'home/home',
            name: 'home',
          },
          {
            meta: { title: currentPathObj.meta.title },
            path: '',
            name: '',
          },
          {
            meta: { title: childObj.meta.title },
            path: currentPathObj.path + '/' + childObj.path,
            name,
          },
        ];
      }
    }
    vm.$store.commit('siss/setCurrentPath', currentPathArr);

    return currentPathArr;
  }
  public timeFormat(time: any, fmt: string) {
    if (!time) {
      return "";
    }
    if (time.toString().indexOf('-') > 0) {
      time = time.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '/') // 将 '-' 替换成 '/'
      if (time.indexOf('.') > -1) {
        time = time.slice(0, time.indexOf('.')) // 删除小数点及后面的数字
      }
    }
    let that: Date = new Date(time);
    let o: object = {
      "M+": that.getMonth() + 1,
      "d+": that.getDate(),
      "h+": that.getHours(),
      "H+": that.getHours(),
      "m+": that.getMinutes(),
      "s+": that.getSeconds(),
      "q+": Math.floor((that.getMonth() + 3) / 3),
      "S": that.getMilliseconds()
    };
    let week: object = {
      "0": "\u65e5",
      "1": "\u4e00",
      "2": "\u4e8c",
      "3": "\u4e09",
      "4": "\u56db",
      "5": "\u4e94",
      "6": "\u516d"
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (that.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ?
        (RegExp.$1.length > 2 ? "\u661f\u671f" : "\u5468") : "") + week[that.getDay() + ""]);
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  }
  public padZero(num: number | string, targetLength = 2): string {
    let str = num + '';
    while (str.length < targetLength) {
      str = '0' + str;
    }
    return str;
  }
  public getWeekDate(day: number): string {
    let weeks = new Array("周日", "周一", "周二", "周三", "周四", "周五", "周六");
    day = day > 6 ? day % 7 : day;
    let week = weeks[day];
    return week;
  }
  public getDates(now: any): string {
    return now.getMonth() + 1 + '月' + now.getDate() + '日'
  }
  public numberRange(num: number, min: number, max: number): number {
    return Math.min(Math.max(num, min), max);
  }
  public numberTimes(n: number, iteratee: (index: number) => any[]) {
    let index = -1;
    const result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  public urlEncode(param: any, key: string, encode: boolean) {
    const that: any = this;
    if (param == null) { return ''; }
    let paramStr: string = '';
    const t: any = typeof (param);
    if (t === 'string' || t === 'number' || t === 'boolean') {
      paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
    } else {
      for (const i in param) {
        if (param.hasOwnProperty(i)) {
          const k: string = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
          paramStr += that.urlEncode(param[i], k, encode);
        }
      }
    }
    return paramStr.substr(1);
  }
  public deepClone(obj: any) {
    const objClone: any = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === 'object') {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          // tslint:disable-next-line:jsdoc-format

          if (obj[key] && typeof obj[key] === 'object') {
            objClone[key] = this.deepClone(obj[key]);
          } else {
            // tslint:disable-next-line:jsdoc-format

            objClone[key] = obj[key];
          }
        }
      }
    }
    return objClone;
  }
  public openNewPost(verb: string, url: string, data: any, target: string) {
    const form: any = document.createElement('form');
    form.action = url;
    form.method = verb;
    form.target = target || '_self';
    if (data) {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const input: any = document.createElement('textarea');
          input.name = key;
          // tslint:disable-next-line:max-line-length
          input.value = data[key] instanceof Date ? data[key].toJSON() : typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key];
          form.sissendChild(input);
        }
      }
    }
    form.style.display = 'none';
    form.enctype = 'sisslication/json';
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
  public deleteArrayHasOtherArray(currArray: any[], otherArray: any[]): any[] {
    let i: number = currArray.length;
    while (i--) {
      const curr: string = JSON.stringify(currArray[i]);
      let has: boolean = false;
      for (const other of otherArray) {
        if (curr === JSON.stringify(other)) {
          has = true;
          break;
        }
      }
      if (has) {
        currArray.splice(i, 1);
      }
    }
    return currArray;
  }
  public extend(...args: any[]) {
    // tslint:disable-next-line:one-variable-per-declaration
    let options, name, src, srcType, copy, copyType, copyIsArray, clone,
      target = args[0] || {},
      i = 1,
      // tslint:disable-next-line:prefer-const
      length = args.length,
      deep = false;
    if (typeof target === 'boolean') {
      deep = target;
      target = args[i] || {};
      i++;
    }
    if (typeof target !== 'object' && typeof target !== 'function') {
      target = {};
    }
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      // tslint:disable-next-line:no-conditional-assignment
      if ((options = args[i]) !== null) {
        // tslint:disable-next-line:forin
        for (name in options) {
          src = target[name];
          copy = options[name];
          if (target === copy) {
            continue;
          }
          srcType = Array.isArray(src) ? 'array' : typeof src;
          // tslint:disable-next-line:no-conditional-assignment
          if (deep && copy && ((copyIsArray = Array.isArray(copy)) || typeof copy === 'object')) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && srcType === 'array' ? src : [];
            } else {
              clone = src && srcType === 'object' ? src : {};
            }
            target[name] = this.extend(deep, clone, copy);
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }
    return target;
  }
  public GetDistance(x1, y1, x2, y2) {
    let D2R = 0.017453;
    let a2 = 6378137.0;
    let e2 = 0.006739496742337;
    if (!x2 || !y2) {
      return;
    }
    try {
      x1 = x1 * 1;
      y1 = y1 * 1;
      x2 = x2 * 1;
      y2 = y2 * 1;
      let fdLambda = (x1 - x2) * D2R;
      let fdPhi = (y1 - y2) * D2R;
      let fPhimean = ((y1 + y2) / 2.0) * D2R;
      let fTemp = 1 - e2 * (Math.pow(Math.sin(fPhimean), 2));
      let fRho = (a2 * (1 - e2)) / Math.pow(fTemp, 1.5);
      let fNu = a2 / (Math.sqrt(1 - e2 * (Math.sin(fPhimean) * Math.sin(fPhimean))));
      let fz = Math.sqrt(Math.pow(Math.sin(fdPhi / 2.0), 2) + Math.cos(y2 * D2R) * Math.cos(y1 * D2R) * Math.pow(Math.sin(fdLambda / 2.0), 2));
      fz = 2 * Math.asin(fz);
      let fAlpha = Math.cos(y2 * D2R) * Math.sin(fdLambda) * 1 / Math.sin(fz);
      fAlpha = Math.asin(fAlpha);
      let fR = (fRho * fNu) / ((fRho * Math.pow(Math.sin(fAlpha), 2)) + (fNu * Math.pow(Math.cos(fAlpha), 2)));
      return fz * fR;
    } catch (e) {
      return;
    }
  }
  public GetDistanceWithBaiDuGPS(x1, y1, x2, y2, BMap) {
    if (!x1 || !y1 || !x2 || !y2) {
      return;
    }
    let Map = new BMap.Map();
    let point1 = new BMap.Point(x1, y1);
    let point2 = new BMap.Point(x2, y2);
    let dis = Map.getDistance(point1, point2);
    return dis;
  }
  public GetDistanceWithBaiDuGPSQQ(x1, y1, x2, y2, BMap) {
    if (!x1 || !y1 || !x2 || !y2) {
      return;
    }
    //let temppoint1 = this.bMapToQQMap(x1,y1);
    let point1 = new qq.maps.LatLng(y1, x1);
    //let temppoint2 = this.bMapToQQMap(x2,y2);
    let point2 = new qq.maps.LatLng(y2, x2);
    let dis = qq.maps.geometry.spherical.computeDistanceBetween(point1, point2);
    return dis;
  }
  private buildDate(filter: Filter) {
    if (filter.Type === FieldType.Date) {
      if (!!filter.Value) {
        const compare = this.caseCompare(filter.CompareType);
        const date = new Date(filter.Value);
        // tslint:disable-next-line:max-line-length
        return `${filter.FieldName}${compare} DateTime(${date.getFullYear()},${date.getMonth() + 1},${date.getDate()})`;
      } else {
        return '';
      }
    } else if (filter.Type === FieldType.DataRange) {
      if (!!filter.Value) {
        const dates = filter.Value as Date[];
        if (dates.length !== 2) {
          throw new Error('Dates format is error');
        } else if (dates[0] && dates[1]) {
          // tslint:disable-next-line:max-line-length
          return `(${filter.FieldName}>= DateTime(${dates[0].getFullYear()},${dates[0].getMonth() + 1},${dates[0].getDate()}) AND ${filter.FieldName}<= DateTime(${dates[1].getFullYear()},${dates[1].getMonth() + 1},${dates[1].getDate()}))`;
        } else {
          return '';
        }
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  private buildEnum(filter: Filter) {
    const compare = this.caseCompare(filter.CompareType);
    return `${filter.FieldName}${compare}"${filter.Value}"`;
  }
  private buildBoolean(filter: Filter) {
    if (filter.Value == null) {
      return '';
    } else if (filter.Value) {
      return `${filter.FieldName}=true`;
    } else if (!filter.Value) {
      return `${filter.FieldName}=false`;
    } else {
      return '';
    }
  }
  private buildString(filter: Filter) {
    if (!filter.Value) {
      return '';
    }
    const compare = this.caseCompare(filter.CompareType);
    return `${filter.FieldName}${compare}("${filter.Value}")`;
  }
  private buildNumber(filter: Filter) {
    const compare = this.caseCompare(filter.CompareType);
    return `${filter.FieldName}${compare}${filter.Value}`;
  }
  private caseCompare(compareType: CompareType) {
    switch (compareType) {
      case CompareType.Greater: return '>';
      case CompareType.Less: return '<';
      case CompareType.Equal: return '=';
      case CompareType.GreaterOrEqual: return '>=';
      case CompareType.LessOrEqual: return '<=';
      case CompareType.Contains: return '.Contains';
      case CompareType.StartWith: return '.StartWith';
      case CompareType.EndWith: return '.EndWith';
      case CompareType.NotEqual: return '!=';
    }
  }
  public getRandomArrayElements(arr, count) {
    var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
    while (i-- > min) {
      index = Math.floor((i + 1) * Math.random());
      temp = shuffled[index];
      shuffled[index] = shuffled[i];
      shuffled[i] = temp;
    }
    return shuffled.slice(min);
  }
  //倒计时--1 开始   2 结束
  public countDownTime(date) {
    date = date || {}
    let day = 0, hour = 0, min = 0, sec = 0;
    let timeDistance = 0;
    let dateNow = new Date().getTime();
    let dateTime = new Date(date.replace(/\-/g, '/').replace(/T/g, ' ')).getTime();
    let countdownTime = Math.abs(dateTime - dateNow);
    day = Math.floor(countdownTime / 86400000);
    timeDistance = countdownTime - day * 86400000;
    hour = Math.floor(timeDistance / 3600000);
    timeDistance =
      countdownTime -
      day * 86400000 -
      hour * 3600000;
    min = Math.floor(timeDistance / 60000);
    timeDistance =
      countdownTime -
      day * 86400000 -
      hour * 3600000 -
      min * 60000;
    sec = Math.floor(timeDistance / 1000);
    return {
      day: day < 10 ? '0' + day : day,
      hour: hour < 10 ? '0' + hour : hour,
      min: min < 10 ? '0' + min : min,
      sec: sec < 10 ? '0' + sec : sec,
    }
  }
  //获取商户版本信息0：微商城 1：微会员
  getIsMemberVersion() {
    let memberVersion = sessionStorage.getItem("ismemberVersion");
    return memberVersion;
  }

  //获取微会员禁止进入页面
  isMinVip(to) {
    if (this.MinVipMenuList.indexOf(to) > -1) {
      return true;
    }
    return false;
  }

  //返回需要是会员权限的页面
  getVipPageNames() {
    //let vipPageNames: any = ["addressedit", "selectaddressedit","confirmorder", "confirmorderwithoutcart", "confirmpointorder", "spellgrouporder","getcoupon","chargefee","mycoupon","checkin"];
    let vipPageNames: any = [""];
    return vipPageNames;
  }

  //返回需要是会员权限的页面
  getVipPageNamesNew() {
    let vipPageNames: any = ["addressedit", "selectaddressedit", "confirmorder", "confirmorderwithoutcart", "confirmpointorder", "spellgrouporder", "getcoupon", "chargefee", "mycoupon", "checkin", "ecard", "distributioncenter"];
    //let vipPageNames: any = [""];
    return vipPageNames;
  }

  //返回需要选择服务门店的页面
  geBranchPageNames() {
    let branchPageNames: any = ["show", "details", "oederdetails", "groupdetail", "grouporderdetail", "seckilldetail", "predetails", "buyfullpromotiondetail", "goodsdetails", "todetails", "spellgrouporder", "confirmorderwithoutcart", "confirmorder"];
    //let vipPageNames: any = [""];
    return branchPageNames;
  }
  getUserInfo() {
    let enshopid = this.siss.auth.getenshopid();
    let userInfo = localStorage[enshopid + '_userInfo'] ? JSON.parse(localStorage[enshopid + '_userInfo']) : {};
    return userInfo;
  }

  canRegister() {

  }
  toRegister(to: any, from: any, next: any) {
    let shopid = this.siss.auth.getenshopid();
    let shareopenid = sessionStorage.getItem(shopid + "_shareopenid");
    if (shareopenid) {
      window.wx.miniProgram.navigateTo({
        url: "/pages/common/common?scene=" + "60" + shareopenid
      });
    } else {
      //将服务门店编号传入
      this.IsShareAppIdShow(shopid)
    }
  }
  //距离方案，时，判断是否在区域内
  IsInRegions(currentOrderman: any, overLaysPoints: any, BMap: any, BMapLib: any) {
    let IsInFlag = false;
    let desPoint = new BMap.Point(currentOrderman.longitude, currentOrderman.latitude);
    overLaysPoints.forEach(el => {
      if (el.drawingMode == "circle") {
        var point = new BMap.Point(el.points[0].lng, el.points[0].lat);
        var circle = new BMap.Circle(point, el.radius, el.styleOptions); //创建圆
        var result = BMapLib.GeoUtils.isPointInCircle(desPoint, circle);
        if (result == true) {
          IsInFlag = true;
          return false;
        }
      }
      if (el.drawingMode == "polygon" || el.drawingMode == "rectangle") {
        let points = [];
        el.points.forEach(p => {
          var point = new BMap.Point(p.lng, p.lat);
          points.push(point);
        });

        var polygon = new BMap.Polygon(points, el.styleOptions); //创建多边形
        var result = BMapLib.GeoUtils.isPointInPolygon(desPoint, polygon);
        if (result == true) {
          IsInFlag = true;
          return false;
        }
      }
    });
    return IsInFlag;
  }
  public ComplexCustomOverlay(point, text) {
    this._point = point;
    this._text = text;
  }
  //距离方案，时，判断是否在区域内(腾讯地图)
  IsInRegionsQQ(currentOrderman: any, overLaysPoints: any, BMap: any, BMapLib: any) {
    let map = new qq.maps.Map();
    let IsInFlag = false;
    let desPoint = new qq.maps.LatLng(currentOrderman.latitude, currentOrderman.longitude);
    overLaysPoints.forEach(el => {
      if (el.drawingMode == "circle") {
        let point = new qq.maps.LatLng(el.points[0].lat, el.points[0].lng);
        var circle = new qq.maps.Circle({
          map: map,
          center: point,
          radius: el.radius,
          fillColor: "#00f",
          strokeWeight: 5
        })
        var result = circle.getBounds().contains(desPoint);
        //var circle = new BMap.Circle(point, el.radius, el.styleOptions); //创建圆
        //var result = BMapLib.GeoUtils.isPointInCircle(desPoint, circle);
        if (result == true) {
          IsInFlag = true;
          return false;
        }
      }
      if (el.drawingMode == "polygon" || el.drawingMode == "rectangle") {
        let points = [];
        el.points.forEach(p => {
          var point = new qq.maps.LatLng(p.lat, p.lng);
          points.push(point);
        });
        var polygon = new qq.maps.Polygon({
          path: points,
          strokeColor: '#000000',
          strokeWeight: 5,
          fillColor: '#111111',
          map: map
        });
        //var polygon = new BMap.Polygon(points, el.styleOptions); //创建多边形
        var result = polygon.getBounds().contains(desPoint);
        if (result == true) {
          IsInFlag = true;
          return false;
        }
      }
    });
    return IsInFlag;
  }
  //————————————————
  //版权声明：本文为CSDN博主「四域公子」的原创文章，遵循CC 4.0 BY-SA版权协议，转载请附上原文出处链接及本声明。
  //原文链接：https://blog.csdn.net/qq_36377037/java/article/details/86479796
  // public pi:any = 3.14159265358979324;
  // public a:any = 6378245.0;
  // public ee:any = 0.00669342162296594323;
  /*判断是否在国内，不在国内则不做偏移*/
  outOfChina(lon, lat) {
    if ((lon < 72.004 || lon > 137.8347) && (lat < 0.8293 || lat > 55.8271)) {
      return true;
    } else {
      return false;
    }
  }
  transformLat(x, y) {
    var pi: any = 3.14159265358979324;
    var a: any = 6378245.0;
    var ee: any = 0.00669342162296594323;
    var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * pi) + 40.0 * Math.sin(y / 3.0 * pi)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * pi) + 320 * Math.sin(y * pi / 30.0)) * 2.0 / 3.0;
    return ret;
  }

  transformLon(x, y) {
    var pi: any = 3.14159265358979324;
    var a: any = 6378245.0;
    var ee: any = 0.00669342162296594323;

    var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * pi) + 40.0 * Math.sin(x / 3.0 * pi)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * pi) + 300.0 * Math.sin(x / 30.0 * pi)) * 2.0 / 3.0;
    return ret;
  }
  //地球坐标系(WGS-84)转火星坐标系(GCJ)：
  public transform(wgLat, wgLon) {
    var pi: any = 3.14159265358979324;
    var a: any = 6378245.0;
    var ee: any = 0.00669342162296594323;

    var mars_point = { lon: 0, lat: 0 };
    // if (this.outOfChina(wgLat,wgLon))
    // {
    //     mars_point.lat = wgLat;
    //     mars_point.lon = wgLon;
    //     return mars_point;
    // }
    var dLat = this.transformLat(wgLon - 105.0, wgLat - 35.0);
    var dLon = this.transformLon(wgLon - 105.0, wgLat - 35.0);
    var radLat = wgLat / 180.0 * pi;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi);
    dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi);
    mars_point.lat = wgLat + dLat;
    mars_point.lon = wgLon + dLon;
    return mars_point
  }
  //火星坐标转百度坐标：
  //public x_pi:any=3.14159265358979324 * 3000.0 / 180.0;
  marsTobaidu(mars_point) {
    var x_pi: any = 3.14159265358979324 * 3000.0 / 180.0;

    var baidu_point = { lon: 0, lat: 0 };
    var x = mars_point.lon;
    var y = mars_point.lat;
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
    baidu_point.lon = z * Math.cos(theta) + 0.0065;
    baidu_point.lat = z * Math.sin(theta) + 0.006;
    return baidu_point;
  }
  //地球坐标系(WGS-84)转百度坐标
  public gpstobaidu(wgLat, wgLon) {
    var mars_point = this.transform(wgLat, wgLon);
    var baidu_point = this.marsTobaidu(mars_point);
    return baidu_point;
  }
  bMapToQQMap(lon, lat) {
    var x_pi = 3.14159265358979324 * 3000.0 / 180.0;
    var mars_point = { lon: 0, lat: 0 };
    var x = parseFloat(lon) - 0.0065;
    var y = parseFloat(lat) - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    mars_point.lon = z * Math.cos(theta);
    mars_point.lat = z * Math.sin(theta);
    return mars_point;
  }
  /**
  * 坐标转换，百度地图坐标转换成腾讯地图坐标
  * lng 腾讯经度（pointy）
  * lat 腾讯纬度（pointx）
  * 经度>纬度
  */
  bMapToQQMap1(lng, lat) {
    var qq_point = { lon: 0, lat: 0 };
    if (lng == null || lng == '' || lat == null || lat == '') {
      var qq_point;
    }

    var x_pi = 3.14159265358979324;
    var x = parseFloat(lng) - 0.0065;
    var y = parseFloat(lat) - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    var lng = (z * Math.cos(theta)).toFixed(7);
    var lat = (z * Math.sin(theta)).toFixed(7);
    qq_point.lat = parseFloat(lat);
    qq_point.lon = parseFloat(lng);
    return qq_point;
  }

  /**
  * 坐标转换，腾讯地图转换成百度地图坐标
  * lng 腾讯经度（pointy）
  * lat 腾讯纬度（pointx）
  * 经度>纬度
  */

  qqMapToBMap(lng, lat) {
    if (lng == null || lng == '' || lat == null || lat == '')
      return [lng, lat];
    var x_pi = 3.14159265358979324;
    var x = parseFloat(lng);
    var y = parseFloat(lat);
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
    var lng = (z * Math.cos(theta) + 0.0065).toFixed(5);
    var lat = (z * Math.sin(theta) + 0.006).toFixed(5);
    return [lng, lat];
  }

  getIsQQMap() {
    return true;
  }

  filterAddPriceActStatus(addPrice) {
    let meetRank = addPrice.meetRankList[0]
    if (meetRank.thresholdType == 1) {
      let thresholdValue1 = meetRank.thresholdValue / 100
      let amount = 0
      addPrice.normalGoods.filter(items => items.Checked).map(items => {
        amount += Number(items.Price) * items.Count
      })
      if (amount >= Number(thresholdValue1)) {
        return true
      } else {
        return false
      }
    } else {
      let thresholdValue2 = meetRank.thresholdValue
      let amount = 0
      addPrice.normalGoods.filter(items => items.Checked).map(items => {
        amount += items.Count
      })
      if (amount >= thresholdValue2) {
        return true
      } else {
        return false
      }
    }
  }
  //获取浏览器名称和版本
  getBrower = () => {
    let agent = navigator.userAgent.toLowerCase();
    let browser = { appname: 'unknown', version: '0' };
    if (/(qqbrowser|ubrowser)\D+(\d[\d.]*)/.test(agent)) {//qq浏览器,UC浏览器
      browser.appname = RegExp.$1;
      browser.version = RegExp.$2;
    } else if (/se[\s\.a-zA-Z\d]+metasr/.test(agent)) {
      browser.appname = 'sougou';
      browser.version = '0';
    } else if (/(msie|firefox|opera|chrome|netscape)\D+(\d[\d.]*)/.test(agent)) {
      browser.appname = RegExp.$1;
      browser.version = RegExp.$2;
    } else if (/version\D+(\d[\d.]*).*safari/.test(agent)) { // safari  
      browser.appname = 'safari';
      browser.version = RegExp.$2;
    }
    return browser;
    // console.log(browser);
  }
  //获取浏览器的操作系统平台
  getPlatform = () => {
    let os = {
      platform: navigator.platform.toLowerCase(),
    };
    return os;
    // console.log(os);
  };
  //获取当前设备类型
  getDevice = () => {
    let agent = navigator.userAgent.toLowerCase();
    let result = {
      device: function () {
        if (/windows/.test(agent)) {
          return 'windows pc';
        } else if (/iphone|ipod/.test(agent) && /mobile/.test(agent)) {
          return 'iphone';
        } else if (/ipad/.test(agent) && /mobile/.test(agent)) {
          return 'ipad';
        } else if (/android/.test(agent) && /mobile/.test(agent)) {
          return 'android';
        } else if (/linux/.test(agent)) {
          return 'linux pc';
        } else if (/mac/.test(agent)) {
          return 'mac';
        } else {
          return 'other';
        }
      }(),
    };
    return result;
    // console.log(result);
  };
  getReferer = () => {
    if (document.referrer) {
      return document.referrer;
    } else {
      return false;
    }
  }
  getURL = () => {
    if (document.URL) {
      return document.URL;
    } else {
      return false;
    }
  }
  //构建商品详情埋点基础信息
  buildProductDetailLog: any = (activityId: any,
    activityName: any,
    item_no: any,
    item_name: any
  ) => {
    let logObj = {
      activityId: activityId,
      activityName: activityName,
      eventId: 10100,
      eventType: 3,
      productSkuCode: item_no,
      productSkuName: item_name
    }
    this.buildlog(logObj)
  }
  //构建添加购物车或者直接下单按钮埋点基础信息
  buildAddCartLog: any = (
    item_no: any,
    item_name: any
  ) => {
    let logObj = {
      activityId: '',
      activityName: '',
      eventId: 10002,
      eventType: 3,
      productSkuCode: item_no,
      productSkuName: item_name
    }
    this.buildlog(logObj)
  }
  //构建添加购物车或者直接下单按钮埋点基础信息
  buildLoginLog: any = () => {
    let logObj = {
      // activityId: '',
      // activityName: '',
      eventId: 10001,
      eventType: 3,
      // productSkuCode: '',
      // productSkuName: ''
    }
    return this.loginLog(logObj)
  }
  loginLog: any = (eventInfo: any) => {
    return new Promise(resolve => {
      eventInfo.appId = 10000;
      eventInfo.eventType = 3;
      // eventInfo.token = 'Bearer ' + window.siss.auth.getToken()
      eventInfo.currentTime = Date.now()
      eventInfo.latitude = sessionStorage.getItem("latitude")
      eventInfo.longitude = sessionStorage.getItem("longitude")
      console.log('调用了埋点=============', eventInfo)
      resolve(eventInfo)
    })
    // try {
    //   // let currentenv: any = process.env.VUE_APP_CURENV
    //   // let logString
    //   // if (currentenv.indexOf("production") > -1) {
    //   //   logString = "https://wxdshop.sissyun.com.cn/mall/minimall/statistics-service/log.gif?"
    //   // } else {
    //   //   logString = "https://testsixunwxd.sissyun.com/mall/minimall/statistics-service/log.gif?"
    //   // }
    //
    //   // eventInfo.branchNo = branchno
    //   // eventInfo.referer = this.getReferer()
    //   // eventInfo.os = this.getPlatform().platform
    //   // eventInfo.screen = window.screen.width
    //   // eventInfo.browser = this.getBrower().appname
    //   // eventInfo.cardId = this.getUserInfo().cardId
    //   // eventInfo.deviceType = this.getDevice().device
    //   // eventInfo.url = this.getURL()
    //   // eventInfo.screen = window.screen.width
    //   // eventInfo.ip = ''
    //   console.log("获取经纬度", eventInfo.latitude, eventInfo.longitude)
    //   // let imgDom = document.createElement("img")
    //   // imgDom.src = logString + qs.stringify(eventInfo)
    //   // document.appendChild(imgDom)
    // } catch (error) {
    //
    // }
  }
  //构建埋点路径
  buildlog: any = (eventInfo: any) => {
    try {
      let currentenv: any = process.env.VUE_APP_CURENV
      let logString
      if (currentenv.indexOf("production") > -1) {
        logString = "https://wxdshop.sissyun.com.cn/mall/minimall/statistics-service/log.gif?"
      } else {
        logString = "https://testsixunwxd.sissyun.com/mall/minimall/statistics-service/log.gif?"
      }

      let servicebranch = sessionStorage.getItem("servicebranch")
      let branchno = "0";
      if (servicebranch != null && servicebranch != undefined) {
        let branch = JSON.parse(servicebranch)
        branchno = branch.branch_no
      }

      eventInfo.appId = 10000;
      eventInfo.eventType = 3;
      eventInfo.branchNo = branchno
      eventInfo.referer = this.getReferer()
      eventInfo.os = this.getPlatform().platform
      eventInfo.screen = window.screen.width
      eventInfo.token = 'Bearer ' + window.siss.auth.getToken()
      eventInfo.currentTime = Date.now()
      eventInfo.browser = this.getBrower().appname
      eventInfo.cardId = this.getUserInfo().cardId
      eventInfo.deviceType = this.getDevice().device
      eventInfo.url = this.getURL()

      eventInfo.currentTime = Date.now()
      eventInfo.screen = window.screen.width
      eventInfo.ip = ''
      eventInfo.latitude = sessionStorage.getItem("latitude")
      eventInfo.longitude = sessionStorage.getItem("longitude")
      console.log("获取经纬度", eventInfo.latitude, eventInfo.longitude)

      let imgDom = document.createElement("img")
      imgDom.src = logString + qs.stringify(eventInfo)
      document.appendChild(imgDom)
    } catch (error) {

    }

  }
  // 隐藏手机号中间数
  hidePhone(phone) {
    if (!phone) return ''
    return phone.replace(phone.substring(3,7), "****")
  }
  // 隐藏姓名
  formatName(name) {
    let newStr
    try {
      if (!name) return
      let reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
      if (reg.test(name)) {
        return name
      }
      if (name.length === 2) {
        newStr = name.substr(0, 1) + '*'
      } else if (name.length > 2) {
        let char = ''
        for (let i = 0, len = name.length - 2; i < len; i++) {
          char += '*'
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1)
      } else {
        newStr = name
      }
      if (!newStr) {
        return name
      }
      return newStr
    } catch (e) {
      console.log(e)
      return name
    }
  }
}
const util = new Util();
export default util;
